export const PROJECT_NAME = 'tasks'
